var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-openai-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("whatsappChannel.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("OpenAI API KEY")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { placeholder: "OpenAI API KEY", name: "apiKey" },
                model: {
                  value: _vm.form.apiKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "apiKey", $$v)
                  },
                  expression: "form.apiKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper ai-assistant" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                staticClass: "ai-assistant",
                attrs: {
                  content:
                    "Eğer aktif etmez iseniz, yapay asistan kullanımları Supsis tarafından sağlanır ay sonunda faturalandırılır.",
                },
              },
              [
                _vm._v(
                  "\n                    Yapay Zeka Asistan Kullanımını Dahil Et\n                    "
                ),
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" help "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("a-switch", {
                  model: {
                    value: _vm.form.settings.useAIAssistant,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.settings, "useAIAssistant", $$v)
                    },
                    expression: "form.settings.useAIAssistant",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [_vm._v("\n                " + _vm._s(_vm.$t("message.save")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }